export default __webpack_public_path__ + "static/media/childDevelopmentblob3.d9fb1f24.svg";